import React, { useCallback, useEffect, useState } from 'react'
import Link from 'next/link'

import MenuBarIcon from '@/assets/svg/MenuBarIcon'
import XBarIcon from '@/assets/svg/XBarIcon'

import Logo from '../../Logo'

export default function Header() {
  const [activeSection, setActiveSection] = useState('')

  const handleScrollNavbar = useCallback(() => {
    const { scrollY } = window
    const navbar = document.getElementById('navbar')
    if (!navbar) return
    const isBackgroundWhite = navbar.classList.contains('!bg-white')
    if (scrollY !== 0 && !isBackgroundWhite) {
      navbar.classList.add('!bg-white')
      navbar.classList.add('!shadow-white-navbar-shadow')
    } else if (scrollY === 0 && isBackgroundWhite) {
      navbar.classList.remove('!bg-white')
      navbar.classList.remove('!shadow-white-navbar-shadow')
    } else {
      //
    }
  }, [])

  const handleScroll = useCallback(() => {
    handleScrollNavbar()

    // Check which section is in viewport
    const sections = [
      'cach-hoat-dong',
      'loi-ich',
      'huong-dan-kich-hoat',
      'faq',
      'tu-van',
    ]
    const headerHeight = document.getElementById('navbar')?.offsetHeight || 0

    for (const sectionId of sections) {
      const section = document.getElementById(sectionId)
      if (section) {
        const rect = section.getBoundingClientRect()
        // Add a buffer equal to header height + 50px to consider a section "active" earlier
        if (rect.top <= headerHeight + 50 && rect.bottom >= headerHeight) {
          setActiveSection(sectionId)
          break
        }
      }
    }
  }, [handleScrollNavbar])

  function onToggleMenu() {
    const navLinks = document.querySelector('.offcanvas-body')
    const closeButton = document.querySelector('.navbar-close-button')
    closeButton.classList.toggle('hidden')
    navLinks.classList.toggle('!top-0')
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll)
      return () => window.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])

  return (
    <div
      className="
      flex justify-center
      h-fit
      bg-cover relative bg-payment-ver-2-header
      "
    >
      <div className="max-w-[1920px] lg:w-[1280px] md:w-[768px] w-[394px]">
        <div
          id="navbar"
          className="fixed left-0 w-full flex justify-center z-[99999999] md:bg-transparent bg-white"
        >
          <div
            className="
              flex items-center justify-between z-[999]
              px-4 md:px-8 lg:px-12
              lg:pb-4 lg:pt-5 py-6 lg:w-[1280px] md:w-[768px] w-[375px]
        "
          >
            <nav
              className="w-full  max-w-[1680px] "
              aria-label="Offcanvas navbar large"
            >
              <div className="p-0 flex flex-row justify-between items-center">
                <div className="flex items-center justify-center">
                  <Link
                    href={
                      process.env.NEXT_PUBLIC_REACT_APP_PRODUCTION_PATH || '/'
                    }
                    aria-label="Logo-kiotfinance"
                  >
                    <h2
                      id="kfin-logo"
                      className="mb-0 flex  lg:w-[138px] lg:h-[48px] w-[104px] h-[36px] relative"
                    >
                      <Logo />
                    </h2>
                  </Link>
                </div>

                <div className="offcanvas-body my-auto lg:h-fit font-['Inter'] duration-300 lg:pb-0 pb-[10px] lg:static fixed lg:rounded-none rounded-xl max-md:shadow-navbar-shadow bg-white lg:bg-[transparent]	 lg:min-h-fit top-[-9999px] right-0 lg:w-auto flex items-center md:w-[372px]">
                  <ul className="flex lg:gap-2 h-full lg:flex-row flex-col lg:items-center navbar-nav justify-content-end flex-grow-1 m-0 p-0 lg:w-full w-screen  rounded-[12px]">
                    <li className="py-6 px-[18px] flex justify-between lg:hidden border-solid border-b border-neutral-50">
                      <div className="font-bold text-xl text-text-strong">
                        Mục lục
                      </div>
                      <button
                        className="navbar-close-button hidden"
                        type="button"
                        aria-label="Close"
                        onClick={onToggleMenu}
                      >
                        <XBarIcon />
                      </button>
                    </li>
                    <HeaderLabel
                      label="Cách hoạt động"
                      navigateTo="cach-hoat-dong"
                    />
                    <HeaderLabel label="Lợi ích" navigateTo="loi-ich" />
                    <HeaderLabel
                      label="Hướng dẫn kích hoạt"
                      navigateTo="huong-dan-kich-hoat"
                    />
                    <HeaderLabel label="FAQ" navigateTo="faq" />

                    <div className="flex max-lg:w-full ml-3">
                      <a
                        id="navbar-register-button"
                        className="
                          lg:px-4 lg:py-2 flex max-lg:justify-center p-[18px] py-0 lg:my-0 my-[18px] lg:leading-5 leading-[26px]
                          lg:bg-brand-primary-500 hover:lg:bg-brand-primary-600 active:lg:bg-brand-primary-700 bg-white lg:rounded-[99px] lg:justify-center items-center lg:gap-2 lg:inline-flex cursor-pointer
                          lg:items-center font-semibold lg:text-sm text-lg
                          lg:text-white text-text-strong text-center text-decoration-none
                          hover:lg:border-l-0 hover:lg:text-white hover:text-brand-primary-500
                        "
                        href="#tu-van"
                        onClick={e => {
                          e.preventDefault()
                          const element = document.getElementById('tu-van')
                          if (element) {
                            const headerHeight =
                              document.getElementById('navbar')?.offsetHeight ||
                              0
                            const offset = headerHeight + 20 // Thêm 20px spacing
                            const elementPosition =
                              element.getBoundingClientRect().top +
                              window.pageYOffset
                            window.scrollTo({
                              top: elementPosition - offset,
                              behavior: 'smooth',
                            })
                          }
                        }}
                      >
                        Nhận tư vấn
                      </a>
                    </div>
                  </ul>
                </div>
                <button
                  className="lg:hidden block open-close-button"
                  aria-label="Open"
                  type="button"
                  onClick={onToggleMenu}
                >
                  <span className="navbar-toggler-icon">
                    <MenuBarIcon />
                  </span>
                </button>
              </div>
            </nav>
          </div>
        </div>
        <div className="w-full flex ">
          <div
            className="
              flex lg:justify-between h-full max-md:w-full  md:flex-row flex-col
              lg:mr-[69px] md:mr-10 lg:mb-0 mb-8
              lg:ml-12 md:ml-8
              lg:w-[1168px] md:w-[696px] w-[349px]
          "
          >
            <div
              className="max-md:mx-auto
                 lg:mb-[139px] md:mb-[60px]
                 lg:mt-[194px] md:mt-[100px] mt-[116px]
                 text-navy
                 xl:max-w-[639px] lg:max-w-[603px]
                 w-full flex flex-col gap-6 md:gap-[22px] justify-center
              "
            >
              <div className="flex items-center w-fit max-md:text-center">
                <h1
                  id="header-title"
                  className="
                    color-brand-primary-850
                    lg:text-[54px] text-[40px] lg:font-extrabold font-bold lg:leading-[68px] leading-[48px]
                    xl:w-[639px] lg:w-[603px] md:w-[273px] w-[394px]
                  "
                >
                  Giải pháp thông báo thanh toán QR
                </h1>
              </div>
              <div className="flex justify-between lg:h-fit ">
                <div className="flex lg:gap-1 md:gap-[2.25px] gap-1 flex-col">
                  <div className="text-brand-navy lg:text-base md:text-[8px] text-base font-normal xl:w-[639px] lg:w-[603px]">
                    Khi khách hàng quét mã QR để thanh toán cho đơn hàng,
                    KiotViet sẽ thông báo tiền về và xác nhận giao dịch thành
                    công ngay trên màn hình thu ngân
                  </div>
                </div>
              </div>
              <a
                id="header-register-button"
                className="
                px-8 py-4
                shadow-register-button w-fit bg-brand-primary-500 hover:bg-brand-primary-600 active:bg-brand-primary-700 rounded-[99px] justify-center items-center gap-2 inline-flex
                text-[20px] font-bold max-md:m-auto
                text-white lg:leading-7 text-center text-decoration-none cursor-pointer
              "
                href="#tu-van"
                onClick={e => {
                  e.preventDefault()
                  const element = document.getElementById('tu-van')
                  if (element) {
                    const headerHeight =
                      document.getElementById('navbar')?.offsetHeight || 0
                    const offset = headerHeight + 20 // Thêm 20px spacing
                    const elementPosition =
                      element.getBoundingClientRect().top + window.pageYOffset
                    window.scrollTo({
                      top: elementPosition - offset,
                      behavior: 'smooth',
                    })
                  }
                }}
              >
                Nhận tư vấn miễn phí
              </a>
            </div>
            <div className="relative max-md:flex max-md:justify-center max-md:overflow-hidden md:w-fit w-full flex items-center lg:mt-0 mt-[21px]">
              <div
                id="hero-background-girl"
                className="
                  relative lg:h-[406px] md:h-[351px] h-[289px] bg-payment-ver-2-banner-icon bg-cover
                  lg:w-[552px] md:w-[388px] w-[394px]
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const HeaderLabel = ({ label, navigateTo }) => {
  const [activeSection, setActiveSection] = useState('')

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById(navigateTo)
      if (section) {
        const headerHeight =
          document.getElementById('navbar')?.offsetHeight || 0
        const rect = section.getBoundingClientRect()
        if (rect.top <= headerHeight + 50 && rect.bottom >= headerHeight) {
          setActiveSection(navigateTo)
        } else if (activeSection === navigateTo) {
          setActiveSection('')
        }
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [navigateTo, activeSection])

  function onRemoveMenu() {
    const navLinks = document.querySelector('.offcanvas-body')
    const closeButton = document.querySelector('.navbar-close-button')
    closeButton.classList.toggle('hidden')
    navLinks.classList.toggle('!top-0')
  }

  const handleClick = e => {
    e.preventDefault()
    onRemoveMenu()

    const element = document.getElementById(navigateTo)
    if (element) {
      const headerHeight = document.getElementById('navbar')?.offsetHeight || 0
      const offset = headerHeight + 20 // Thêm 20px spacing
      const elementPosition =
        element.getBoundingClientRect().top + window.pageYOffset
      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth',
      })
    }
  }

  return (
    <li className="lg:py-0 lg:mx-0 py-[4px] mx-2">
      <a
        id={`${navigateTo}-link`}
        href={`#${navigateTo}`}
        className={`
          font-semibold text-sm font-['Inter'] leading-5 text-text-strong text-decoration-none
          px-3 py-2 flex items-center rounded-[99px]
          hover:bg-white hover:text-brand-primary-500 hover:shadow-shadow-blurs
          active:bg-brand-primary-50 active:text-brand-primary-500
          ${
            activeSection === navigateTo
              ? 'bg-[#e6f1fe] !text-brand-primary-500'
              : ''
          }
        `}
        onClick={handleClick}
      >
        {label}
      </a>
    </li>
  )
}
